import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#0F172A] text-white p-14">
        <span className="flex items-center gap-2.5 font-display font-black text-lg"><img src="/logo.png?v=2" alt="Indian TV Box logo" className="w-9 h-9 rounded-lg" />INDIANTV<span className="text-[#FF5722]">.</span>BOX</span>
        <div>
          <h1 className="font-display font-black text-5xl tracking-tighter leading-none">Control<br />room.</h1>
          <p className="text-neutral-400 mt-6 max-w-sm">Manage boxes, subscriptions and orders in one place.</p>
        </div>
        <span className="font-mono-x text-xs text-neutral-600">Authorised personnel only</span>
      </div>
      <div className="flex items-center justify-center p-8">
        <motion.form onSubmit={submit} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-sm" data-testid="admin-login-form">
          <div className="w-11 h-11 bg-[#FF5722] text-white flex items-center justify-center mb-6"><Lock size={18} /></div>
          <h2 className="font-display text-3xl font-bold mb-2">Admin sign in</h2>
          <p className="text-neutral-500 text-sm mb-8">Enter your credentials to continue.</p>
          <label className="font-mono-x text-[11px] uppercase tracking-[0.15em] text-neutral-500">Email</label>
          <input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-neutral-300 px-3 py-2.5 mt-1 mb-4 focus:border-[#FF5722] outline-none" />
          <label className="font-mono-x text-[11px] uppercase tracking-[0.15em] text-neutral-500">Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-neutral-300 px-3 py-2.5 mt-1 mb-4 focus:border-[#FF5722] outline-none" />
          {err && <p className="text-red-500 text-sm mb-4" data-testid="login-error">{err}</p>}
          <button disabled={busy} data-testid="login-submit" className="w-full bg-[#0F172A] text-white py-3 font-medium disabled:opacity-50">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </motion.form>
      </div>
    </div>
  );
}
